/**
 * BH Product Helpers
 * Extracted from size-guide.js — non-sizer utilities that remain needed:
 *   1. Size/Length selector placeholders ("SELECT A SIZE" / "SELECT A LENGTH")
 *   2. Size table image modal
 *   3. Delivery date display
 *
 * Translations injected via window.sizeGuideI18n in layout/theme.liquid.
 */

/* ============================================================
   SIZE SELECTOR PLACEHOLDER
   ============================================================ */
(function() {
  var i18n = window.sizeGuideI18n || {};
  var placeholder = i18n.select_size || 'SELECT A SIZE';
  var lengthPlaceholder = i18n.select_length || 'SELECT A LENGTH';
  var dimensionPlaceholder = i18n.select_dimension || 'SELECT A SIZE';
  var quantityPlaceholder = i18n.select_quantity || 'SELECT QUANTITY';
  var materialPlaceholder = i18n.select_material || 'SELECT MATERIAL';
  var sizeSelected = {};
  var lengthSelected = {};
  var dimensionSelected = {};
  var quantitySelected = {};
  var materialSelected = {};

  function initSizeSelectors() {
    document.querySelectorAll('.size-select-container').forEach(function(container) {
      var selectBtn = container.querySelector('.select');
      var selectSpan = container.querySelector('.select span');
      if (!selectBtn || !selectSpan) return;

      var id = selectSpan.id || Math.random().toString();

      if (!sizeSelected[id]) {
        if (!selectSpan.dataset.original) {
          selectSpan.dataset.original = selectSpan.textContent;
        }
        selectSpan.textContent = placeholder;
      }

      selectBtn.addEventListener('click', function() {
        sizeSelected[id] = true;
      }, { once: true });

      attachPhantomClickFix(container, selectSpan, id, sizeSelected);
    });
  }

  function initLengthSelectors() {
    document.querySelectorAll('.length-select-container').forEach(function(container) {
      var selectBtn = container.querySelector('.select');
      var selectSpan = container.querySelector('.select span');
      if (!selectBtn || !selectSpan) return;

      var id = selectSpan.id || Math.random().toString();

      if (!lengthSelected[id]) {
        if (!selectSpan.dataset.original) {
          selectSpan.dataset.original = selectSpan.textContent;
        }
        selectSpan.textContent = lengthPlaceholder;
      }

      selectBtn.addEventListener('click', function() {
        lengthSelected[id] = true;
      }, { once: true });

      attachPhantomClickFix(container, selectSpan, id, lengthSelected);
    });
  }

  function initQuantitySelectors() {
    document.querySelectorAll('.quantity-select-container').forEach(function(container) {
      var selectBtn = container.querySelector('.select');
      var selectSpan = container.querySelector('.select span');
      if (!selectBtn || !selectSpan) return;

      var id = selectSpan.id || Math.random().toString();

      if (!quantitySelected[id]) {
        if (!selectSpan.dataset.original) {
          selectSpan.dataset.original = selectSpan.textContent;
        }
        selectSpan.textContent = quantityPlaceholder;
      }

      selectBtn.addEventListener('click', function() {
        quantitySelected[id] = true;
      }, { once: true });

      attachPhantomClickFix(container, selectSpan, id, quantitySelected);
    });
  }

  function initMaterialSelectors() {
    document.querySelectorAll('.material-select-container').forEach(function(container) {
      var selectBtn = container.querySelector('.select');
      var selectSpan = container.querySelector('.select span');
      if (!selectBtn || !selectSpan) return;

      var id = selectSpan.id || Math.random().toString();

      if (!materialSelected[id]) {
        if (!selectSpan.dataset.original) {
          selectSpan.dataset.original = selectSpan.textContent;
        }
        selectSpan.textContent = materialPlaceholder;
      }

      selectBtn.addEventListener('click', function() {
        materialSelected[id] = true;
      }, { once: true });

      attachPhantomClickFix(container, selectSpan, id, materialSelected);
    });
  }

  function initDimensionSelectors() {
    document.querySelectorAll('.dimension-select-container').forEach(function(container) {
      var selectBtn = container.querySelector('.select');
      var selectSpan = container.querySelector('.select span');
      if (!selectBtn || !selectSpan) return;

      var id = selectSpan.id || Math.random().toString();

      if (!dimensionSelected[id]) {
        if (!selectSpan.dataset.original) {
          selectSpan.dataset.original = selectSpan.textContent;
        }
        selectSpan.textContent = dimensionPlaceholder;
      }

      selectBtn.addEventListener('click', function() {
        dimensionSelected[id] = true;
      }, { once: true });

      attachPhantomClickFix(container, selectSpan, id, dimensionSelected);
    });
  }

  /* Bug fix: Shopify pre-checks the first variant radio. The placeholder text
     hides this from the user, but the radio stays checked. Clicking the
     pre-checked option fires no `change` event, so the popover doesn't close.
     This handler detects clicks on already-checked options and forces UI sync. */
  function attachPhantomClickFix(container, selectSpan, id, selectedMap) {
    container.addEventListener('click', function(e) {
      var label = e.target.closest('.popover__value-option');
      if (!label) return;
      var radio = label.querySelector('input[type="radio"]');
      if (!radio || !radio.checked) return;

      var labelSpan = label.querySelector('span');
      var labelText = labelSpan ? labelSpan.textContent.trim() : '';
      if (labelText) {
        selectedMap[id] = true;
        selectSpan.textContent = labelText;
      }

      var popover = container.querySelector('x-popover');
      if (popover) {
        if (typeof popover.hide === 'function') popover.hide();
        else if (typeof popover.close === 'function') popover.close();
        else popover.removeAttribute('open');
      }
    });
  }

  function watchChanges() {
    var sizeContainers = document.querySelectorAll('.size-select-container');
    var lengthContainers = document.querySelectorAll('.length-select-container');
    var dimensionContainers = document.querySelectorAll('.dimension-select-container');
    var quantityContainers = document.querySelectorAll('.quantity-select-container');
    var materialContainers = document.querySelectorAll('.material-select-container');

    if (sizeContainers.length === 0 && lengthContainers.length === 0 && dimensionContainers.length === 0 && quantityContainers.length === 0 && materialContainers.length === 0) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        var container = mutation.target.closest('.size-select-container, .length-select-container, .dimension-select-container');
        if (!container) return;

        var selectSpan = container.querySelector('.select span');
        if (!selectSpan) return;
        var id = selectSpan.id || '';

        if (container.classList.contains('size-select-container')) {
          if (!sizeSelected[id] && selectSpan.textContent !== placeholder) {
            selectSpan.textContent = placeholder;
          }
        } else if (container.classList.contains('quantity-select-container')) {
          if (!quantitySelected[id] && selectSpan.textContent !== quantityPlaceholder) {
            selectSpan.textContent = quantityPlaceholder;
          }
        } else if (container.classList.contains('material-select-container')) {
          if (!materialSelected[id] && selectSpan.textContent !== materialPlaceholder) {
            selectSpan.textContent = materialPlaceholder;
          }
        } else if (container.classList.contains('dimension-select-container')) {
          if (!dimensionSelected[id] && selectSpan.textContent !== dimensionPlaceholder) {
            selectSpan.textContent = dimensionPlaceholder;
          }
        } else {
          if (!lengthSelected[id] && selectSpan.textContent !== lengthPlaceholder) {
            selectSpan.textContent = lengthPlaceholder;
          }
        }
      });
    });

    sizeContainers.forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
    lengthContainers.forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
    dimensionContainers.forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
    quantityContainers.forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
    materialContainers.forEach(function(el) {
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSizeSelectors();
      initLengthSelectors();
      initDimensionSelectors();
      watchChanges();
    });
  } else {
    initSizeSelectors();
    initLengthSelectors();
    initDimensionSelectors();
    initQuantitySelectors();
    initMaterialSelectors();
    watchChanges();
  }
})();

/* ============================================================
   SIZE TABLE IMAGE MODAL
   ============================================================ */
(function() {
  var tableBtnElement = document.getElementById('hfkkeafkrb');
  var tableModal = document.getElementById('brhfbkwqpo');
  var closeBtn = document.querySelector('.xvcnvxnqwe');

  if (tableBtnElement && tableModal) {
    tableBtnElement.addEventListener('click', function(e) {
      e.preventDefault();
      tableModal.style.display = 'flex';
    });
  }

  if (closeBtn && tableModal) {
    closeBtn.addEventListener('click', function() {
      tableModal.style.display = 'none';
    });
  }

  if (tableModal) {
    tableModal.addEventListener('click', function(e) {
      if (e.target.id === 'brhfbkwqpo') {
        tableModal.style.display = 'none';
      }
    });
  }
})();

/* ============================================================
   DELIVERY DATE
   ============================================================ */
(function() {
  function initDeliveryDate() {
    var i18n = window.sizeGuideI18n || {};

    var days, months;
    try { days = (typeof i18n.delivery_days === 'string' ? JSON.parse(i18n.delivery_days) : i18n.delivery_days); } catch(e) { days = null; }
    try { months = (typeof i18n.delivery_months === 'string' ? JSON.parse(i18n.delivery_months) : i18n.delivery_months); } catch(e) { months = null; }
    days = days || ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    months = months || ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var dateFormat = i18n.delivery_date_format || 'mdy';

    var oggi = new Date();
    var dataConsegna = new Date(oggi);
    dataConsegna.setDate(oggi.getDate() + 3);

    var giornoSettimana = days[dataConsegna.getDay()];
    var giorno = dataConsegna.getDate();
    var mese = months[dataConsegna.getMonth()];
    var anno = dataConsegna.getFullYear();

    var testoData = dateFormat === 'dmy'
      ? giornoSettimana + ' ' + giorno + ' ' + mese + ' ' + anno
      : giornoSettimana + ', ' + mese + ' ' + giorno + ', ' + anno;

    var el = document.getElementById('data-consegna');
    if (el) el.textContent = testoData;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryDate);
  } else {
    initDeliveryDate();
  }
})();
